import { render, staticRenderFns } from "./CarGalery.vue?vue&type=template&id=00fdc51e&scoped=true"
import script from "./CarGalery.vue?vue&type=script&lang=js"
export * from "./CarGalery.vue?vue&type=script&lang=js"
import style0 from "./CarGalery.vue?vue&type=style&index=0&id=00fdc51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdc51e",
  null
  
)

export default component.exports